import React from "react";

import {
  ActionsContainer,
  ActionsColumn,
  ActionsColumnDivider,
  ActionsButton,
  ActionsColumnsContainer,
} from "./styles";
import { useCardsStore } from "../../../../stores/use-cards-store";
import { movePermission } from "../../helpers/actions";

import ArrowLeft from "./icons/ArrowLeft";
import ArrowRight from "./icons/ArrowRight";
import Duplicate from "./icons/Duplicate";
import Emoji from "./icons/Emoji";
import Image from "./icons/Image";
import Link from "./icons/Link";
import Trash from "./icons/Trash";
import { CARD_TYPE } from "../../../../optics/components/drawers/settings/features/cards/defaults";

const Actions = ({ card }) => {
  const { data, hoverCard, setData, removeCard, moveCard, setCard, setAction } =
    useCardsStore((state) => ({
      data: state.data,
      hoverCard: state.hoverCard,
      setData: state.setData,
      removeCard: state.removeCard,
      moveCard: state.moveCard,
      setCard: state.setCard,
      setAction: state.setAction,
    }));

  const { canMoveLeft, canMoveRight } = movePermission({
    data,
    cardId: hoverCard.card.id,
  });

  const hasIconPicker =
    hoverCard.config.type === CARD_TYPE.EMOJI ||
    hoverCard.config.type === CARD_TYPE.NUMBER;

  return (
    <ActionsContainer onClick={(event) => event.stopPropagation()}>
      <ActionsColumnsContainer>
        <ActionsColumn>
          {hasIconPicker && (
            <ActionsButton
              onClick={() => {
                setAction({ card: hoverCard, drawer: "icon" });
                setCard(card);
              }}
            >
              <Emoji />
            </ActionsButton>
          )}

          {hoverCard.config.type === "image" && (
            <ActionsButton
              onClick={() => {
                setAction({ card: hoverCard, drawer: "image" });
                setCard(card);
              }}
            >
              <Image />
            </ActionsButton>
          )}

          <ActionsButton
            onClick={() => {
              setAction({ card: hoverCard, drawer: "link" });
              setCard(card);
            }}
          >
            <Link />
          </ActionsButton>
          <ActionsButton
            onClick={() => {
              const clonedCard = {
                ...hoverCard,
                card: { ...hoverCard.card, id: crypto.randomUUID() },
              };
              setData(clonedCard);
              setCard(clonedCard);
            }}
          >
            <Duplicate />
          </ActionsButton>
          <ActionsButton onClick={() => removeCard(hoverCard.card.id)}>
            <Trash />
          </ActionsButton>
        </ActionsColumn>
        <ActionsColumnDivider />
        <ActionsColumn>
          <ActionsButton
            isClickable={canMoveLeft}
            onClick={() => moveCard(hoverCard.card.id, "left")}
          >
            <ArrowLeft />
          </ActionsButton>
          <ActionsButton
            isClickable={canMoveRight}
            onClick={() => moveCard(hoverCard.card.id, "right")}
          >
            <ArrowRight />
          </ActionsButton>
        </ActionsColumn>
      </ActionsColumnsContainer>
    </ActionsContainer>
  );
};

export default Actions;
